import { render, staticRenderFns } from "./Circulars.vue?vue&type=template&id=b67714f6&scoped=true&"
import script from "./Circulars.vue?vue&type=script&lang=js&"
export * from "./Circulars.vue?vue&type=script&lang=js&"
import style0 from "./Circulars.vue?vue&type=style&index=0&id=b67714f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b67714f6",
  null
  
)

export default component.exports